const store = {
  bounds: {
    ww: window.innerWidth,
    wh: window.innerHeight,
  },
};

export default store;